import { render, staticRenderFns } from "./UserEditTabSocial.vue?vue&type=template&id=381b4ad5&"
import script from "./UserEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./UserEditTabSocial.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports